import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: '#DE1834',
        color: 'white',
        alignItems: 'center',
        textAlign: 'center',
        height: 40,
        fontSize: 9
    },
    PcsYear: {
        width: '50%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    Internal: {
        paddingLeft: '2px',
        width: '45%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    AccreditedCeActivity: {
        paddingLeft: '2px',
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    PersonalLearning: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    ResearchOrTraining: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    Total: {
        width: '40%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    ClinicalAudit: {
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    CreditsOnTarget: {
        width: '30%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    VerificationStatus: {
        width: '40%',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingLeft: '7px'
    }
});

interface Props {
    legacyTitles: string[] | null;
}

const LegacyReceiptTableHeader = ({legacyTitles}: Props) => {
    return (
        <View style={styles.container}>
            <Text style={styles.PcsYear}>{legacyTitles === null ? '' : legacyTitles[0]}</Text>
            <Text style={styles.AccreditedCeActivity}>{legacyTitles === null ? '' : legacyTitles[2]}</Text>
            <Text style={styles.Internal}>{legacyTitles === null ? '' : legacyTitles[3]}</Text>
            <Text style={styles.PersonalLearning}>{legacyTitles === null ? '' : legacyTitles[4]}</Text>
            <Text style={styles.ResearchOrTraining}>{legacyTitles === null ? '' : legacyTitles[5]}</Text>
            <Text style={styles.Total}>{legacyTitles === null ? '' : legacyTitles[6]}</Text>
            <Text style={styles.ClinicalAudit}>{legacyTitles === null ? '' : legacyTitles[7]}</Text>
            <Text style={styles.CreditsOnTarget}>{legacyTitles === null ? '' : legacyTitles[8]}</Text>
        </View>
    )
};

export default LegacyReceiptTableHeader;